document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.cust-image-with-horizontal-tabs');
    if (!section) return;

    const tabItems = section.querySelectorAll('.tab-item');
    const imageItems = section.querySelectorAll('.image-item');

    tabItems.forEach(tab => {
        tab.addEventListener('click', () => {
            const index = tab.getAttribute('data-index');

            // Remove active class from all tabs and images
            tabItems.forEach(t => t.classList.remove('active'));
            imageItems.forEach(img => img.classList.remove('active'));

            // Add active class to clicked tab and corresponding image
            tab.classList.add('active');
            const targetImage = section.querySelector(`.image-item[data-index="${index}"]`);
            if (targetImage) {
                targetImage.classList.add('active');
            }

            // Scroll the active tab into view on mobile
            if (window.innerWidth <= 768) {
                tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
        });
    });
});
